// extracted by mini-css-extract-plugin
module.exports = {"overlay":"SettingsModal_overlay__1sKFO","modal":"SettingsModal_modal__1E5YI","modalButton":"SettingsModal_modalButton__WM8bW"};